export class ContactInfo {
  constructor(
    public readonly firstName: string,
    public readonly lastName: string,
    public readonly street: string,
    public readonly line1: string,
    public readonly line2: string,
    public readonly city: string,
    public readonly state: string,
    public readonly zip: string,
    public readonly phoneNumber: string,
    public id: string,
    public readonly type: string
  ) {}

  hasSameAddress(contactInfo: ContactInfo): boolean {
    return (
      contactInfo &&
      this.street === contactInfo.street &&
      this.line1 === contactInfo.line1 &&
      this.line2 === contactInfo.line2 &&
      this.city === contactInfo.city &&
      this.state === contactInfo.state &&
      this.zip === contactInfo.zip
    );
  }
}
